import i18n from '../../locales/index'
import restful from '../vuex'
import { Message } from 'view-design'
import axios from '@/libs/axios_ai';
import axios2 from 'axios'

const state = {
  ...restful.states('ai'),
  query: { page: 1, limit: 10 },
}
const getters = {
  ...restful.getters('ai')
}
const actions = {
  async index ({ commit }, params) {
    const { query } = this.state.ai
    query.store_id = localStorage.getItem('SHOPID')
    const path = '/getByPage'
    const final_params = Object.assign(query, params)
    const response = await axios.get(path, { params: final_params })
    commit('setRecords', response.data)
    if (response.count) {
      commit('setMeta', {
        total: response.count,
        current: query.page,
        pageSize: query.limit
      })
    }
    commit('loading', false)
  },
  async show ({ commit, state }, id) {
    const { ais } = state
    commit('setRecord', ais.find(item => item.id === id))
  },
  async update ({ commit }, params) {
    const { _mute_ = false, ...others } = params;
    const body = new FormData()
    for (const key in others) {
      body.append(key, others[key]);
    }
    await axios.post(`/updateItem`, body)
    commit('updateRecordInRecords', others)
    if (!_mute_) {
      Message.success(i18n.t('store_modules_ai_1312'))
    }
  },
  async destroy ({ commit }, id) {
    const body = new FormData()
    body.append('id', id);
    await axios.post(`/deleteItem`, body)
    commit('removeRecordInRecords', id)
    Message.success(i18n.t('store_modules_ai_1313'))
  },
  async clear ({ commit }) {
    commit('clearRecord')
  },

  // 第三方AI管理
  async destroy_all ({ commit, dispatch }) {
    await axios2({
      method: 'post',
      url: 'ai/destroy_all',
    });
    Message({
      message: i18n.t('store_modules_ai_1314'),
      type: 'success',
    });
  },
  async delete_label ({ commit, dispatch }, params) {
    // fresh_product_id: params.fresh_product_id,
    await axios2({
      method: 'post',
      url: 'ai/delete_label',
      data: {
        fresh_product_id: params.id,
      }
    });
    Message({
      message: i18n.t('store_modules_ai_1314'),
      type: 'success',
    });
  },
  async delete_img ({ commit, dispatch }, params) {
    // delete_img  params: {unique_id: unique_id}
    await axios2({
      method: 'post',
      url: 'ai/delete_img',
      data: params
    });
    Message({
      message: i18n.t('store_modules_ai_1314'),
      type: 'success',
    });
  },
  async query ({ commit, dispatch }, params) {
    // query repsponse {unique_id: ''}
    await axios2({
      method: 'post',
      url: 'ai/query',
      data: params
    });
    Message({
      message: i18n.t('store_modules_ai_1314'),
      type: 'success',
    });
  },
}
const mutations = {
  ...restful.mutations('ai'),
  resetQuery: (state) => {
    state.query = { page: 1, limit: 10 }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
